// extracted by mini-css-extract-plugin
export default {"container":"Guidelines_container__ysGd4","subheader":"Guidelines_subheader__xDREi","paragraph":"Guidelines_paragraph__5U7cf"};